import { productBrandStyles } from "@insite/content-library/Components/ProductBrand";

if (productBrandStyles.nameLink) {
    productBrandStyles.nameLink = {
        typographyProps: {
            color: "#003049 !important",
        },
    };
}
